import { useAppSettings } from '@/context/app-settings';

// Simplified public settings hook that derives from AppSettings
// This is used by public-facing components to avoid heavy dependencies
export function usePublicSettings() {
  const { settings, loading } = useAppSettings();
  
  if (!settings || loading) {
    return {
      config: {
        show_logo: true,
        logo_url: '/lovable-uploads/727626ab-d59a-4f99-aed6-fe8a671929b5.png',
        show_welcome_message: true,
        use_custom_welcome_message: false,
        welcome_message_custom: {},
        show_exhibit_access: true,
        exhibit_access_buttons: {
          enterNumber: true,
          scanQR: true,
          favorites: true,
          browseTours: true
        },
        show_visitor_info: true,
        show_background_shapes: true,
        show_home_image: false,
        home_image_settings: {
          imageUrl: '',
          altText: '',
          caption: '',
          size: 'medium'
        },
        element_order: ['logo', 'welcomeMessage', 'exhibitAccess', 'visitorInfo'],
        typography_source: 'google',
        typography_google_font: 'Inter',
        typography_custom_font_url: null,
        button_labels: {}
      },
      loading
    };
  }

  const homeSettings = settings.home_settings_v2;
  
  // Transform AppSettings to match the old public_config format for compatibility
  const config = {
    show_logo: homeSettings.showLogo,
    logo_url: homeSettings.logoUrl,
    show_welcome_message: homeSettings.showWelcomeMessage,
    use_custom_welcome_message: homeSettings.useCustomWelcomeMessage,
    welcome_message_custom: homeSettings.welcomeMessageCustom,
    show_exhibit_access: homeSettings.showExhibitAccess,
    exhibit_access_buttons: homeSettings.exhibitAccessButtons,
    show_visitor_info: homeSettings.showVisitorInfo,
    show_background_shapes: homeSettings.showBackgroundShapes,
    show_home_image: homeSettings.showHomeImage,
    home_image_settings: homeSettings.homeImageSettings,
    element_order: homeSettings.elementOrder,
    typography_source: settings.typography.source,
    typography_google_font: settings.typography.googleFont,
    typography_custom_font_url: settings.typography.customFontUrl,
    button_labels: settings.button_labels
  };

  return { config, loading };
}